import { Module } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { TypeOrmModule } from "@nestjs/typeorm";
import { VendorEntity } from "./vendor.entity";
import { VendorController } from "./vendor.controller";
import { VendorService } from "./vendor.service";



@Module({
    imports: [
        TypeOrmModule.forFeature([VendorEntity]),
    ],
    controllers: [VendorController],
    providers: [VendorService, ApplicationExceptionHandler]
})
export class VendorModule {

}